/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SalesRankings {
    angular.module("meevo.plugins.salesRankings", []);
}